import React, { useState } from "react";
import { Calendar, Clock, ExternalLink, Phone, MapPin } from "lucide-react";

const meetings = [
  {
    title: "இறை சித்தம் குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "கார்மேல் ஆவிக்குரிய திருச்சபை, No 8 சிவன் நகர் மெயின் ரோடு, புது வண்ணாரப்பேட்டை, சென்னை.81",
    contact: "90803 55086",
    link: null,
  },
  {
    title: "ஆன்மீகபாதை குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ஆரோக்கிய அன்னை ஆலயம், விவேகானந்தா தெரு, ரெட்டேரி, கொளத்தூர், சென்னை.99",
    contact: "9941520460",
    link: "https://goo.gl/maps/y2YNnEUYUhWc1hgPA",
  },
  {
    title: "ஒற்றுமை குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "செயின்ட் ஜோசப் பள்ளி, எம்.கே.பி நகர், சென்னை.39",
    contact: "9094979799",
    link: "https://maps.app.goo.gl/wXLQLGU7jCe7GA3r9?g_st=iw",
  },
  {
    title: "சேவை குழு",
    days: ["Monday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "E.C.I. செயின்ட் பீட்டர்ஸ் சர்ச், பஞ்செட்டி ரோடு, (ஆதித்தனார் அரங்கம், ஸ்விப்ட் மருத்துவமனை எதிரில்), (பொன்னேரி பஸ் டிப்போ அருகில்), பொன்னேரி",
    contact: "07708690933 / 09629812933",
    link: "https://maps.app.goo.gl/9czdTgpSAT2wYse5A?g_st=iw",
  },
  {
    title: "லிபர்டி குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ரெய்சன் ரீடிமெர்ஸ் சர்ச், 2வது தெரு, யுனைடெட் காலனி, கோடம்பாக்கம், சென்னை:600024",
    contact: "08939769828 / 09840481565",
    link: "https://maps.app.goo.gl/r15KNXxqc4132qo36",
  },
  {
    title: "திங்கள் நிலா குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "அரசு பள்ளி, பாரதி நகர், மணியனூர், சேலம்",
    contact: "94987 27688",
    link: null,
  },
  {
    title: "சுயநம்பிக்கை குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அரசு ஆண்கள் மேல்நிலைப்பள்ளி அருகில், சந்தைப்பேட்டை, கொண்டலாம்பட்டி, சேலம்",
    contact: "94987 27689",
    link: null,
  },
  {
    title: "ஆன்மீக சிந்தனை குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "பனமரத்துப்பட்டி கோலி கார்டன் நர்சரி பள்ளி சேலம்",
    contact: null,
    link: null,
  },
  {
    title: "குழுவின் பெயர்",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "லைசாண்டர் மருத்துவமணை 3வது மாடியில் prayer ஹால், விருதுநகர்",
    contact: "9840994219",
    link: "https://maps.app.goo.gl/8L3Tkn5cuV4kGfW3A",
  },
  {
    title: "நம்பிக்கை பெற்ற வளர்ச்சி குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "சி.எஸ்.ஐ தூய பேதுரு ஆலயம், தாசர்புரம், திருநின்றவூர்-602024",
    contact: "098406 30533 / 094449 53976",
    link: "https://maps.app.goo.gl/LM7ggWcZbtNAdWQB9",
  },
  {
    title: "கடவுளின் கொடை குழு",
    days: ["Monday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },
  {
    title: "மேற்கு சென்னை ஒற்றுமை குழு",
    days: ["Monday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "சி எஸ் ஐ இமானுவேல் சர்ச் பெருமாள் கோவில் தெரு நெற்குன்றம்  சென்னை -6000107 லேண்ட்மார்க் - நாதன் பள்ளிக்கூடம்",
    contact: "7010996241 / 6383306109",
    link: "https://maps.app.goo.gl/Y3mWebWzNzk38Hsf6",
  },
  {
    title: "அதிசய செவ்வாய் குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "புனித அந்தோணியார் மழலையர் மற்றும் தொடக்கப் பள்ளி, பொப்பிலி ராஜன் சாலை, கே. கே. நகர், சென்னை :- 600078",
    contact: "8667374547",
    link: "https://maps.app.goo.gl/C4EDbJrKT2JpgcEe9",
  },
  {
    title: "சிந்தனை குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "அன்னை வேளாங்கண்ணி பள்ளி, சர்மா நகர்",
    contact: "9382141642",
    link: "https://maps.app.goo.gl/418FnoBvVkqP9AC86?g_st=iw",
  },
  {
    title: "மனசாட்சி குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "எழில் மாடல் ஸ்கூல், எழில் நகர்",
    contact: "9941680190",
    link: "https://maps.app.goo.gl/zWi6Xjm9ku6AvB258?g_st=iw",
  },
  {
    title: "பிரீடம் குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "C.S.I சர்ச் தீர்த்தகிரியம்பட்டு, ரெட்ஹில்ஸ், சென்னை.52",
    contact: "8608200914",
    link: "https://maps.app.goo.gl/vYGW47NCDmuewThs5",
  },
  {
    title: "நேச்சுரல் லைஃப் குழு",
    days: ["Tuesday"],
    times: [{ start: "18:30", end: "20:00" }],
    location: "E.C.I சர்ச் (செல்வ மஹால் அருகில்), மீஞ்சூர்",
    contact: "7401207656",
    link: "https://maps.app.goo.gl/gukAK1KzeQ1xrjg8A?g_st=iw",
  },
  {
    title: "ஆன்மீக ஒளி குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "சிஎல்சி-செகினா அசெம்பிளி சர்ச், ESSAR பெட்ரோல் பங்க் அருகில், 105,B பிளாக் 5வது மெயின் ரோடு, தணிகாசலம் நகர், சென்னை.600110",
    contact: null,
    link: "https://maps.app.goo.gl/T3eUYoAhSF96iXbt9?g_st=iw",
  },
  {
    title: "ரெக்கவரி மீட்பு குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அரசு நடுநிலைப்பள்ளி, பாலமுருகன் மண்டபம் பின்புறம், காட்டூர், சேலம்",
    contact: "94987 27690",
    link: null,
  },
  {
    title: "ஆன்மீக வாழ்க்கை குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "பஞ்சாயத்து ஒன்றியம் துவக்கப்பள்ளி சின்னசீரகாபாடி, சேலம்",
    contact: "83002 73032",
    link: null,
  },
  {
    title: "குழுவின் பெயர்",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "CSI பிரார்த்தனைக் கூடம் பழைய பேருந்து நிலையம் அருகில், விருதுநகர்",
    contact: "8098651363",
    link: "https://maps.app.goo.gl/PU9ZeBZzkks39v238",
  },
  {
    title: "சரியான நேரம் குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ஊராட்சி ஒன்றிய நடுநிலைப்பள்ளி, குன்றத்தூர், [அண்ணா சிலை பின்புறம்]",
    contact: null,
    link: "https://maps.app.goo.gl/xpzac7tmv9579BkM9",
  },
  {
    title: "மேற்கு சென்னை ஒற்றுமை குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "பெருமாள் கோவில் தெரு நெற்குன்றம் சென்னை -6000107",
    contact: "9384637171",
    link: "https://maps.app.goo.gl/Y3mWebWzNzk38Hsf6",
  },
   {
    title: "ஸ்டெப்பிங் ஸ்டோன்ஸ் குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ரெஹோபோத் ரிவைவல் சர்ச் டி.ஜே.எஸ் கல்லூரி (அருகில் ) டி.ஜே.எஸ் நகர் பெருவாயல் கவரைப்பேட்டை: 601206",
    contact: "9840490585",
    link: "https://maps.app.goo.gl/47Uj2QHGoWfN7eH18",
  },
   {
    title: "கடவுளின் கொடை குழு",
    days: ["Tuesday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },
  {
    title: "மேற்கு சென்னை ஒற்றுமை குழு",
    days: ["Tuesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "சி எஸ் ஐ இமானுவேல் சர்ச் பெருமாள் கோவில் தெரு நெற்குன்றம்  சென்னை -6000107 லேண்ட்மார்க் - நாதன் பள்ளிக்கூடம்",
    contact: "7010996241 / 6383306109",
    link: "https://maps.app.goo.gl/Y3mWebWzNzk38Hsf6",
  },
  
  {
    title: "ஆன்மீக உற்று குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "சிஎல்சி-செகினா அசெம்பிளி சர்ச், ESSAR பெட்ரோல் பங்க் அருகில், 105,B பிளாக் 5வது மெயின் ரோடு, தணிகாசலம் நகர், சென்னை.600110",
    contact: "9940143470",
    link: "https://maps.app.goo.gl/T3eUYoAhSF96iXbt9?g_st=iw",
  },
  {
    title: "அன்னை குழு",
    days: ["Wednesday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "அந்த்ரேய ஆலயம், திருவொற்றியூர் ஹைரோடு, பொன்னேரி (கோர்ட் எதிரில்)",
    contact: "8056407591",
    link: "https://maps.app.goo.gl/MiSibqfLxF1LEWgW7?g_st=iw",
  },
  {
    title: "பரிகார குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "C. S. I தூய யோவான் ஆலயம், (சண்முக தியோட்டர் எதிரில்) மூலக்கடை",
    contact: "9941633086",
    link: "https://maps.app.goo.gl/QzfWKyU49qudM6CC6?g_st=iw",
  },
  {
    title: "ஃபோர்த் டைமென்ஷன் குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "காவேரி பள்ளி, K K சாலை, சாலிகிராமம், சென்னை -78 (L. V. பிரசாத் லேப் அருகில்)",
    contact: "9884008544",
    link: "https://maps.app.goo.gl/FmHopiJ81t5Wj8RWA",
  },
  {
    title: "ஸ்பிரிச்சுவல் கேட்வே குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ஸ்ரீ கணபதி சச்சிதானந்த ஆசிரமம், SGS சாரிடபுள் கிளினிக், பேபி நகர், வேளச்சேரி, சென்னை-42",
    contact: "8754433458 / 9789197933",
    link: "https://maps.app.goo.gl/R44C1CakeoGNFiKJA",
  },
  {
    title: "புதிய பாதை குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "கொண்டித்தோப்பு காவலர் குடியிருப்பு, மூலக்கொத்தரம், சென்னை 79",
    contact: "9840243698",
    link: null,
  },
  {
    title: "வாழையடி வாழை குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "இந்திரா நகர், பாவை மருத்துவமனை பின்புறம், சீலநாயக்கன்பட்டி, சேலம்",
    contact: "94987 27692",
    link: null,
  },
  {
    title: "மயக்கம் என்ன குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அரசமரத்து விநாயகர் கோவில் அருகில், செவ்வாய்பேட்டை, பாக்கு கடை சந்து தெரு, சேலம்",
    contact: "88075 10456",
    link: null,
  },
   {
    title: "குழு பெயர் -ஒரு நாள் அடிப்படை குழு",
    days: ["Wednesday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "CSI கிறிஸ்து  ஆலயம், எண்-61, உதயம் காலனி, லம்பேர்ட் நகர், ஆற்காடு சாலை, விருகம்பாக்கம்.  சென்னை-600092.",
    contact: "9551888870",
    link:"https://maps.app.goo.gl/RvTudAqtmkpe6Bvy5?g_st=aw",
  },

 {
    title: "கடவுளின் கொடை குழு",
    days: ["Wednesday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },

  {
    title: "மகிழ்ச்சியான சேவை குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "ஊராட்சி ஒன்றிய துவக்கப்பள்ளி, தண்டலம், சென்னை - பெங்களூர் தேசிய நெடுஞ்சாலை",
    contact: "09751581999 / 08220441316",
    link: "https://maps.app.goo.gl/5VDFoctchoKbtqELA",
  },
  {
    title: "விடிவு உண்டு குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "காவேரி பள்ளி, K K சாலை, சாலிகிராமம், சென்னை -78 (L. V. பிரசாத் லேப் அருகில்)",
    contact: "09677256465",
    link: "https://maps.app.goo.gl/FmHopiJ81t5Wj8RWA",
  },
  {
    title: "இறைவன் அருள் குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "கிரேஸ் சர்ச், ஆண்டாள் அவன்யூ, திருவிகநகர், சென்னை.600082",
    contact: "9962032209",
    link: "https://maps.app.goo.gl/m6ds1cHQxR9KcVrq6",
  },
  {
    title: "புதிய பாதை குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "விவேகானந்தா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி, 1/1899 சோலை அம்மன் கோவில் தெரு, அறிஞர் அண்ணா நகர், ரெட்ஹில்ஸ், சென்னை.600052",
    contact: "8939120123",
    link: "https://maps.app.goo.gl/m29CgmCfu7zFWFmZ6",
  },
  {
    title: "சரணாகதி குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "மாதாகோவில் டான் போஸ்கோ பள்ளி (காவல் நிலையம் அருகில்), வியாசர்பாடி",
    contact: "8608750723",
    link: "https://maps.app.goo.gl/8zfRiUWQnRCPtU3V9",
  },
  {
    title: "மறுபிறப்பு குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "குட் ஷெப்பர்ட் சர்ச், 7வது பிளாக், காமாட்சி நகர், எம்.எம்.டி.ஏ காலனி, மதுரவாயல், சென்னை 600095",
    contact: "7092265853",
    link: "https://maps.app.goo.gl/AjmMimnUEivZuMYF9",
  },
  {
    title: "புது ஒளி குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "மாநகராட்சி உயர்நிலைப்பள்ளி, செவ்வாய்சந்தை, மணியனூர், சேலம்",
    contact: "94987 27693",
    link: null,
  },
  {
    title: "வாழ்க்கை வழி குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "ஊராட்சி ஒன்றிய தொடக்கப்பள்ளி, நெய்காரப்பட்டி, சேலம்",
    contact: "94987 27694",
    link: null,
  },
  {
    title: "மிராக்கல் குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "T E L C சர்ச், விருதுநகர்",
    contact: "8870707005, 9360680235",
    link: "https://maps.app.goo.gl/yRZbjqc5xRGxWKbS6",
  },
  {
    title: "சுயமரியாதை குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "TELC பிரார்த்தனைக் கூடம், அல்லம்பட்டி, முக்குரோடு, விருதுநகர்",
    contact: "9585322178, 6384169091",
    link: "https://maps.app.goo.gl/mkkM8iBkky3vjx5L7",
  },
  {
    title: "நலம் நிச்சயம் குழு",
    days: ["Thursday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "இளம்பிள்ளை நெல்லிக்கடை பக்கத்து சந்து",
    contact: "7418368522",
    link: "https://maps.app.goo.gl/mkkM8iBkky3vjx5L7",
  },
   {
    title: "கடவுளின் கொடை குழு",
    days: ["Thursday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },

  {
    title: "மறுபிறவி குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "கோவில் பிள்ளை மெட்ரிகுலேஷன் மேல்நிலை பள்ளி, ராயலா நகர் 2வது மெயின் ரோடு, ராமாபுரம், சென்னை.600089",
    contact: "95661 67508",
    link: "https://maps.app.goo.gl/MziGAaTMjcv4b4PV7",
  },
  {
    title: "மன அமைதி குழு",
    days: ["Friday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "சி. எஸ். ஐ நல் மேய்ப்பர் ஆலயம், கீழ்மேனி தச்சூர் கூட்ரோடு (சாய் சரவணா ஓட்டல் அருகில்), சென்னை.601101",
    contact: "99444 57070",
    link: null,
  },
  {
    title: "விடிவெள்ளி குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அப்போஸ்தல கிறிஸ்துவ சபை, No.59, விநாயகர் கோவில் தெரு, கதிர்வேடு, (கதிர்வேடு பஸ் ஸ்டாப் அருகில்), சென்னை.600066",
    contact: "9176883082",
    link: null,
  },
  {
    title: "கரேஜ் குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "டான் பாஸ்கோ பள்ளி (பிருந்தா தியேட்டர் அருகில்), பெரம்பூர், சென்னை 600011",
    contact: "9941299331",
    link: null,
  },
  {
    title: "அதிசயம் குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அந்தோனியார் ஆலயம், சத்தியமூர்த்தி நகர், வியாசர்பாடி, சென்னை:- 600039",
    contact: "9710873871",
    link: "https://maps.app.goo.gl/EvM7VE1yj7raDUH59",
  },
  {
    title: "கலங்கரை விளக்கம் குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "சின்ன சீரகாபாடி அரசு பள்ளி சேலம் ",
  },
  {
    title: "ஆன்மீக கொடை குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "அசிசி நகர், மாதாவரம் பால் பண்ணை",
    contact: "9840310702",
    link: null,
  },
  {
    title: "கலங்கரை விளக்கம் குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "இந்திரா நகர், பாவை மருத்துவமனை பின்புறம், சீலநாயக்கன்பட்டி, சேலம்",
    contact: null,
    link: null,
  },
  {
    title: "ஆன்மீக விழிப்புணர்வு குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "R C சர்ச் (நகராட்சி அலுவலகம் அருகில்), விருதுநகர்",
    contact: "9360680235, 9952730493",
    link: "https://maps.app.goo.gl/1gVpcAbXbwkq9ocj9",
  },
  {
    title: "வெற்றி நிச்சயம் குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "பெரக்க சர்ச், கண்ணதாசன் நகர், ஜெயா நகர், திருவள்ளூர் தாலுகா ஆபீஸ் பின்புறம்",
    contact: "9791445411",
    link: "https://maps.app.goo.gl/mkgGj5APCPcqesQMA",
  },
  {
    title: "இறை சக்திகுழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "இமானுவேல் சர்ச் பெருமாள் கோயில் தெரு , மதுரவாயல் சென்னை",
    contact: "9600198646",
    link: "https://maps.app.goo.gl/HUs4TaUsQQfehqyL7?g_st=aw",
  },
   {
    title: "கடவுளின் கொடை குழு",
    days: ["Friday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },
  {
    title: "இறைசக்தி குழு",
    days: ["Friday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "கிருஸ்துவசுவிசேஷ சபை பெருமாள் கோயில் தெரு மதுரவாயல்",
    contact: "9841651919 / 63825 74749",
    link: "https://maps.app.goo.gl/QoLNuGFzDZPriBLm7?g_st=ac",
  },
  {
    title: "பிரார்த்தனை குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "டான் போஸ்கோ மேல்நிலை பள்ளி, எருக்கஞ்சேரி (பவித்ரா மருத்துவமனை எதிரில்), சென்னை.118",
    contact: "9551740962",
    link: "https://maps.app.goo.gl/FSCmRZD6ADvyj7SV7?g_st=iwb",
  },
  {
    title: "இறைவன் சித்தம் குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      'செயின்ட் பால்ஸ் சர்ச், டான் பாஸ்கோ நர்சரி & பிரைமரி பள்ளி, "F"பிளாக் மேற்கு தணிகாசலம் நகர் (பிரகாஷ் நகர் போலீஸ் பூத் அருகில்), சென்னை.110',
    contact: "8072 805018",
    link: "https://maps.app.goo.gl/DtfdbC5vBdPFu8gK9?g_st=iw",
  },
  {
    title: "மறுமலர்ச்சி குழு",
    days: ["Saturday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "சி.எஸ்.ஐ.தூய மார்க் ஆலயம், (மீஞ்சூர் பஸ் டிப்போ எதிரில்), மீஞ்சூர்",
    contact: "8754865826",
    link: "https://maps.app.goo.gl/QBo6HneGW6YmT9tY8?g_st=iw",
  },
  {
    title: "நம்பிக்கை குழு",
    days: ["Saturday"],
    times: [{ start: "10:00", end: "11:30" }],
    location:
      "(சிஎல்சி)-செகினா அசெம்பிளி சர்ச், ESSAR பெட்ரோல் பங்க் அருகில், 105,B பிளாக், 5,வது மெயின் ரோடு, தணிகாசலம் நகர், சென்னை.600110",
    contact: "9940303395",
    link: "https://maps.app.goo.gl/GgJyyC7nfKH5MQ9M9?g_st=iw",
  },
  {
    title: "ரெக்கவரி குழு",
    days: ["Saturday"],
    times: [{ start: "18:30", end: "20:00" }],
    location: "கென்னான் பேமிலி ஒர்ஷிப் சென்டர், T.C.ரோடு, கவரப்பேட்டை",
    contact: "9840490585",
    link: "https://maps.app.goo.gl/3bQQyfFqvb4smRkQ7",
  },
  {
    title: "நம்பிக்கையே பதில் குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "எண் 1, லிட்டில் ஏஞ்சல்ஸ் பள்ளி, கல்லூரி சாலை, பரணிபுத்தூர், சென்னை",
    contact: "09962678158 / 09092598291",
    link: "https://maps.app.goo.gl/uH3BdDr5MXqutNZg8",
  },
  {
    title: "இறைவன் சித்தம் குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "CSI பிரார்த்தனைக் கூடம் (பழைய பேருந்து நிலையம் அருகில்), விருதுநகர்",
    contact: "9360680235, 9952730493",
    link: "https://maps.app.goo.gl/PU9ZeBZzkks39v238",
  },
  {
    title: "சுய நேர்மை குழு ",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "எஸ் நாட்டாமங்கலம் அமாணி கொண்டலாம்பட்டி சேலம்",
    contact: "9543140270",
  },
  {
    title: "புனர் ஜென்மம் குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "கல்பாரப்பட்டி புதுப்பாளையம் சேலம்",
    contact: "8438576360",
  },
  {
    title: "தன்னம்பிக்கை குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "தாதகாப்பட்டி கேட் மண்டல ஆபீஸ் அருகில் அரசு பள்ளி சேலம்",
    contact: "9489775887",
  },
  {
    title: "ரெக்கவரி குழு",
    days: ["Saturday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "கென்னான் ஃபேமிலி வொர்ஷிப்சர்ச் தெலுங்கு காலனி ரோடு கவரைப்பேட்டை: 601206",
    contact: "9840490585",
    link: "https://maps.app.goo.gl/yLB2K5CgtmTRN46AA",
  },
 {
    title: "கடவுளின் கொடை குழு",
    days: ["Saturday"],
    times: [{ start: "18:00", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },
  {
    title: "அமர்வு குழு",
    days: ["Sunday"],
    times: [{ start: "11:00", end: "12:30" }],
    location:
      "ஊராட்சி ஒன்றிய துவக்கப்பள்ளி, சென்னை - பெங்களூர் தேசிய நெடுஞ்சாலை, தண்டலம்",
    contact: "09751581999 / 08220441316",
    link: "https://maps.app.goo.gl/5VDFoctchoKbtqELA",
  },
  {
    title: "புதுவாழ்வு குழு",
    days: ["Sunday"],
    times: [{ start: "17:00", end: "18:30" }],
    location:
      "C S l இம்மானுவேல் சர்ச், எண் : 32, தமிழர் வீதி, பத்மநாபன் நகர், சூளை மேடு, சென்னை - 600094",
    contact: "8681005305, 9952078382, 9710958377",
    link: "https://maps.app.goo.gl/h5eGdAjJnaF13Q2v8",
  },
  {
    title: "நான்காம் பரிமாணம் குழுவில்",
    days: ["Sunday"],
    times: [{ start: "17:00", end: "18:30" }],
    location:
      "தூய சீயோன் தேவாலயம், #06, சென்னை திருப்பதி தேசிய நெடுஞ்சாலை, பட்டாபிராம், சென்னை - 600072",
    contact: "097106 00700 / 090257 86963",
    link: "https://maps.app.goo.gl/PFZyAAziv3CvFMiC7",
  },
  {
    title: "சுடர் ஒளி குழு",
    days: ["Sunday"],
    times: [{ start: "11:30", end: "13:00" }],
    location:
      "விவேகானந்தா மெட்ரிகுலேஷன் மேல்நிலைப்பள்ளி, 1/1899, சோலை அம்மன் கோவில் தெரு, அறிஞர் அண்ணா நகர், ரெட்ஹில்ஸ் சென்னை.600052",
    contact: "8939120123",
    link: "https://maps.app.goo.gl/m29CgmCfu7zFWFmZ6",
  },
  {
    title: "ஈச் ஒன் ரீச் ஒன் குழு",
    days: ["Sunday"],
    times: [{ start: "18:00", end: "19:30" }],
    location:
      "மாதாகோவில் டான் போஸ்கோ பள்ளி (காவல் நிலையம் அருகில்), வியாசர்பாடி, சென்னை- 39",
    contact: "8610999381 / 8148480723",
    link: "https://maps.app.goo.gl/8zfRiUWQnRCPtU3V9",
  },
  {
    title: "மகிழ்ச்சியான வாழ்க்கை குழு",
    days: ["Sunday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "செயின்ட் தெரேசா ஆலயம், K.K.R.அவென்யூ, பல்லவன் சாலை (பிருந்தா தியேட்டர் அருகில்), செம்பியம், சென்னை:-600011",
    contact: "7449098768",
    link: "https://maps.app.goo.gl/dchPhkxN1BByTwHv5",
  },
  {
    title: "நான்காம் பரிமாணம் குழு",
    days: ["Sunday"],
    times: [{ start: "18:30", end: "20:00" }],
    location:
      "(VPRC Building) Near Library, விநாயகர் கோயில் எதிரில் தெலுங்கு காலனி ரோடு, கவரப்பேட்டை, சென்னை. 601206",
    contact: null,
    link: null,
  },
  {
    title: "திருப்புமுனை குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "எழில் மாடல் ஸ்கூல், எழில் நகர்",
    contact: "9941680190",
    link: "https://maps.app.goo.gl/zWi6Xjm9ku6AvB258?g_st=iw",
  },
  {
    title: "வானவில் குழு",
    days: ["Sunday"],
    times: [{ start: "17:00", end: "18:30" }],
    location: "புனித அந்தோனியார் ஆலயம், புழல், சென்னை- 600066",
    contact: "9791056304 / 8148892436",
    link: "https://maps.app.goo.gl/nqYn42LDYk3KXQo76",
  },
  {
    title: "அதிசயம் குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "சீமாத்தம்மன் கோவில், சீமாத்தம்மன் கோயில் தெரு, மதுரவாயல் சென்னை 600095",
    contact: "9710 010076",
    link: "https://maps.app.goo.gl/CqddaSe19Szrefay9",
  },
  {
    title: "புக் ரீடிங் மீட்டிங்",
    days: ["Sunday"],
    times: [{ start: "11:00", end: "13:00" }],
    location: "சீலநாயக்கன்பட்டி பாவை ஹாஸ்பிடல் பின்புறம் இந்திரா நகர் சேலம்",
    contact: null,
    link: null,
  },
  {
    title: "இறைஅன்பு குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "அன்பு இல்லம், ஜி.கே. கரட்டூர், திவ்யா தியேட்டர் பின்புறம், சேலம்",
    contact: "94987 27697",
    link: null,
  },
  {
    title: "கடவுளின் கொடை குழு",
    days: ["Sunday"],
    times: [{ start: "17:30", end: "19:00" }],
    location: "வாணியர் குல கம்யூனிட்டி ஹால், குங்கும காளியம்மன் கோவில் தெரு, வேடசந்தூர், திண்டுக்கல் மாவட்டம்",
    contact: "9524553856 / 9865910162",
    link: "https://maps.app.goo.gl/7CpALbhng2gZaHKBA",
  },
  {
    title: "புதுவழி குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location:
      "செயின்ட் மேரிஸ் மருத்துவமனை நான்குரோடு, அரிசிப்பாளையம் மெயின்ரோடு, சேலம்",
    contact: "94987 27698",
    link: null,
  },
  {
    title: "தோழமை குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "ஊராட்சி ஒன்றிய தொடக்கப்பள்ளி, சின்னகட்டிடம், மகுடஞ்சாவடி, சேலம்",
    contact: "94987 27699",
    link: null,
  },
  {
    title: "பிராத்தனை குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "R.C சர்ச் (நகராட்சி அலுவலகம் அருகில்), விருதுநகர்",
    contact: "9952730493, 9360680235",
    link: "https://maps.app.goo.gl/1gVpcAbXbwkq9ocj9",
  },
  {
    title: "அதிசய குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "போலீஸ் பாய்ஸ் கிளப் சின்மயா நகர், கோயம்பேடு",
    contact: "98411 68117 , 92833 78343",
    link: null,
  },
   {
    title: "நான்காம் பரிமாணம் குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "ரிவைவல் சர்ச் டி.ஜே.எஸ் கல்லூரி (அருகில் ) டி.ஜே.எஸ் நகர் பெருவாயல் கவரைப்பேட்டை: 601206",
    contact: "9840490585",
    link: "https://maps.app.goo.gl/47Uj2QHGoWfN7eH18",
  },
  {
    title: "கடவுளின் கொடை குழு",
    days: ["Sunday"],
    times: [{ start: "19:00", end: "20:30" }],
    location: "ரிவைவல் சர்ச் டி.ஜே.எஸ் கல்லூரி (அருகில் ) டி.ஜே.எஸ் நகர் பெருவாயல் கவரைப்பேட்டை: 601206",
    contact: "9840490585",
    link: "https://maps.app.goo.gl/47Uj2QHGoWfN7eH18",
  },
];

const daysOfWeek = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
const tamilDays = [
  "ஞாயிறு",
  "திங்கள்",
  "செவ்வாய்",
  "புதன்",
  "வியாழன்",
  "வெள்ளி",
  "சனி",
];

function App() {
  const [selectedDay, setSelectedDay] = useState("Sunday");

  const getMeetingsForDay = (day: string) => {
    const dayMeetings: Array<{
      meeting: (typeof meetings)[0],
      time: (typeof meetings)[0]["times"][0],
    }> = [];

    meetings.forEach((meeting) => {
      if (meeting.days.includes(day)) {
        meeting.times.forEach((time) => {
          dayMeetings.push({ meeting, time });
        });
      }
    });

    return dayMeetings.sort((a, b) => {
      const timeA = a.time.start.replace(":", "");
      const timeB = b.time.start.replace(":", "");
      return timeA.localeCompare(timeB);
    });
  };

  const formatTime = (time: string) => {
    const [hours, minutes] = time.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  const dayMeetings = getMeetingsForDay(selectedDay);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="container mx-auto px-3 sm:px-4 py-4 sm:py-6 max-w-7xl">
        <header className="mb-6 sm:mb-8 text-center">
          <div className="flex items-center justify-center gap-2 sm:gap-3 mb-2 sm:mb-3">
            <Calendar className="w-8 h-8 sm:w-10 sm:h-10 text-blue-600" />
            <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800">
              தமிழ் ஏஏ கூட்டங்கள்
            </h1>
          </div>
          <p className="text-slate-600 text-sm sm:text-base md:text-lg px-2">
            ஆல்கஹாலிக்ஸ் அனானிமஸ் - தென்னிந்திய GSO குழுக்கள்
          </p>
        </header>

        <div className="mb-4 sm:mb-6">
          <div className="flex flex-wrap gap-1.5 sm:gap-2 justify-center">
            {daysOfWeek.map((day, index) => (
              <button
                key={day}
                onClick={() => setSelectedDay(day)}
                className={`px-3 sm:px-4 md:px-6 py-2 sm:py-2.5 md:py-3 rounded-lg sm:rounded-xl font-semibold transition-all duration-200 shadow-sm text-xs sm:text-sm ${
                  selectedDay === day
                    ? "bg-blue-600 text-white shadow-lg scale-105"
                    : "bg-white text-slate-700 hover:bg-slate-50 hover:shadow-md"
                }`}
              >
                <div className="text-xs sm:text-sm">{tamilDays[index]}</div>
                <div className="text-[10px] sm:text-xs opacity-75">{day}</div>
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6">
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-slate-800 mb-4 sm:mb-6 flex flex-wrap items-center gap-2">
            <Clock className="w-5 h-5 sm:w-6 sm:h-6 text-blue-600 flex-shrink-0" />
            <span>
              {tamilDays[daysOfWeek.indexOf(selectedDay)]} - {selectedDay}
            </span>
            <span className="text-xs sm:text-sm font-normal text-slate-500">
              ({dayMeetings.length} கூட்டங்கள்)
            </span>
          </h2>

          {dayMeetings.length === 0 ? (
            <div className="text-center py-8 sm:py-12 text-slate-500">
              <Calendar className="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 opacity-50" />
              <p className="text-base sm:text-lg">இன்று கூட்டங்கள் இல்லை</p>
            </div>
          ) : (
            <div className="space-y-3 sm:space-y-4">
              {dayMeetings.map((item, index) => (
                <div
                  key={index}
                  className="border border-slate-200 rounded-lg sm:rounded-xl p-3 sm:p-5 hover:shadow-md transition-shadow bg-gradient-to-r from-white to-slate-50"
                >
                  <div className="flex flex-col gap-2 sm:gap-3">
                    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-3">
                      <div className="flex-1">
                        <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                          <div className="bg-blue-100 text-blue-700 px-2 sm:px-3 py-1 rounded-lg text-xs sm:text-sm font-semibold w-fit">
                            {formatTime(item.time.start)} -{" "}
                            {formatTime(item.time.end)}
                          </div>
                          <h3 className="font-bold text-slate-800 text-base sm:text-lg">
                            {item.meeting.title}
                          </h3>
                        </div>

                        <div className="flex items-start gap-2 text-slate-600 text-xs sm:text-sm mb-2">
                          <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-slate-500" />
                          <p className="leading-relaxed">
                            {item.meeting.location}
                          </p>
                        </div>

                        {item.meeting.contact && (
                          <div className="flex items-center gap-2 text-slate-600 text-xs sm:text-sm">
                            <Phone className="w-4 h-4 flex-shrink-0 text-slate-500" />
                            <p>{item.meeting.contact}</p>
                          </div>
                        )}
                      </div>

                      {item.meeting.link && (
                        <a
                          href={item.meeting.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 sm:px-4 py-2 rounded-lg font-medium transition-colors shadow-sm hover:shadow-md w-full sm:w-auto text-sm sm:text-base"
                        >
                          <ExternalLink className="w-4 h-4" />
                          வரைபடம்
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <footer className="mt-6 sm:mt-8 text-center text-slate-600 text-xs sm:text-sm px-4">
          <p>ஆல்கஹாலிக்ஸ் அனானிமஸ் - தென்னிந்திய GSO</p>
          <p className="mt-1">எல்லா கூட்டங்களும் வரவேற்கப்படுகின்றன</p>
        </footer>
      </div>
    </div>
  );
}

export default App;
